import { template as template_e4596d16602f4754bada89b5cc5411d4 } from "@ember/template-compiler";
import PowerSelect from 'eflex/components/power-select';
const LEVELS = [
    'Month',
    'Week',
    'Day',
    'Hour'
];
export default template_e4596d16602f4754bada89b5cc5411d4(`
<div class="level-selector component-bi-dropdown">
  <PowerSelect
    @options={{LEVELS}}
    @selected={{@selectedLevel}}
    @onChange={{@onSelectedLevel}}
  as |level|>
    {{level}}
  </PowerSelect>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
